const BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:9000/api/';
// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'http://127.0.0.1:7000';
// const AGENT_SERVER = 'https://agent.loged.com.br';
const AGENT_SERVER = 'https://apichat.loged.com.br';
// const BACKEND_SERVER = 'https://api.loged.com.br/api/';

const config = {
    // basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs, also don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '',
    defaultPath: '/home',
    // Stack de fonte nativa do sistema (o mesmo truque que a Apple usa na
    // web) - no Mac/iOS renderiza San Francisco de verdade, no Windows cai
    // pra Segoe UI, sem precisar baixar nenhuma fonte externa. Continua
    // trocável pelo seletor em Customização (ver AjusteCustomizacao.js).
    fontFamily: `-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
    borderRadius: 12,
    API_SERVER: BACKEND_SERVER
};

export default config;
